import styled from 'styled-components'
import { fontType, mediaQuery } from '../../styles/functions'

export const ButtonWrapper = styled.div``
export const Button = styled.button`
background: black;
color: white;
min-width: 500px;
border-radius: 8px;
font-size: 28px;
border: 0;
padding: 20px;

	&:hover {
		&:not(:disabled) {
			opacity: 0.8;
		}
	}

	&:disabled {
		background: ${({ theme }) => theme.COLORS.MID_GREY};
		cursor: not-allowed;
	}

	${mediaQuery('sm')(`
	min-width: 400px;
	`)};

	${mediaQuery('xs')(`
	min-width: 300px;
	`)};

	${mediaQuery('xxs')(`
	min-width: 0;
	`)};

	${mediaQuery('xxxs')(`
	//padding: 15px;
	font-size: 26px;
	`)};

	
`
